import { render } from "./Auth_passwrd_reset.vue?vue&type=template&id=549c4be4&scoped=true&ts=true"
import script from "./Auth_passwrd_reset.vue?vue&type=script&lang=ts"
export * from "./Auth_passwrd_reset.vue?vue&type=script&lang=ts"

import "./Auth_passwrd_reset.vue?vue&type=style&index=0&id=549c4be4&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549c4be4"]])

export default __exports__